import React, {  useEffect, useState } from 'react';
import { get, pick } from 'lodash';
import { Button, FileUploader, Icon } from '../components';
import { useForm, useFormValidator } from '../hooks';
import { Status } from '../containers/transaction-history/ContainerTransactionItem';

const initialFormData = {
  application_requirements: []
}

const rules = {
  application_requirements: 'array'
}

export const options = {
  initialFormData,
  rules
}

const ReuploadRequiredDocument = ({ onNext, onPrevious, initialValue, preview, isPassed }) => {
  
  
  const [selectedRequirement, setSelectedRequirement] = useState(null)

  const [value, { onCreateUpdateToListByKey, onSetForm }] = useForm(initialFormData)
  const { response } = useFormValidator(value, rules)
  const appTransaction = JSON.parse(localStorage.getItem('app_transaction')) || {}
  
  useEffect(() => {
    const applicationRequirements = pick(initialValue, Object.keys(initialFormData))
    onSetForm(applicationRequirements)
    setSelectedRequirement(get(applicationRequirements, 'application_requirements.0'))
    // eslint-disable-next-line
  }, [])

  const handleSelect = item => e => {
    e.preventDefault()
    setSelectedRequirement(item)
  }
  
  
  const handleUpload = file => {
    
    let data = {
      target: {
        name: 'application_requirements',
        value: {
          ...selectedRequirement,
          requirement_url: get(file, 'cdnUrl')
        }
      }
    }

    setSelectedRequirement({
      ...selectedRequirement,
      requirement_url: get(file, 'cdnUrl')
    })
    
    onCreateUpdateToListByKey('requirement_id', data)    
  }
  
  const getFileById = (id) => (value.application_requirements && value.application_requirements.find(x => +get(x, 'requirement_id') === +id)) || null
  
  const isAllRequirementsFullfilled = get(value, 'application_requirements').filter(x => +get(x, 'is_required') === 1).every(item => {
    return get(item, 'is_required') && getFileById(get(item, 'requirement_id'))
  })
  
  const isValidationPassed = response.is_passed && isAllRequirementsFullfilled
  
  return (
    <>
      <div className="flex flex-col xl:flex-row pb-3">
        <div className="w-full xl:w-4/12">
          <span className="font-bold text-sm">Attachments</span>
          
          <div className="flex flex-col space-y-2">
            {get(value, 'application_requirements').map((item, i) => {
              return (
                <button type="button"  onClick={handleSelect(item)} key={`requirements${get(item, 'id')}`} className={`py-2 px-1 w-full ${+get(selectedRequirement, 'requirement_id') === +get(item, 'requirement_id') ? 'bg-gray-300' : ''}`}>
                  <div className="flex flex-col w-full text-left space-y-2">
                    <p className="text-sm">
                      <b className="font-medium">{`${i+1}) `}</b>
                      {(get(item, 'is_required') && !getFileById(get(item, 'requirement_id')))
                        ? <span className="rounded px-1 bg-info text-white text-sm mr-2">Required</span>
                        : <Icon.BoxCheck className="inline-flex mr-2"/>
                      }
                      {get(item, 'name')}
                    </p>
                    <p className="text-sm w-full border border-dashed border-white p-1 text-blue-400 ">- {get(item, 'requirement_description')}</p>
                  </div>
                </button>
              )
            })}
          </div>
        </div>
        <div className="flex-1 flex flex-col border-4 border-gray-300 rounded p-2">
          
          <div className="pb-2 border-b-2 border-gray-300 flex">
            {!preview && 
            <div className="flex-1">
              <FileUploader value={get(selectedRequirement, 'requirement_url') || ''} onChange={handleUpload} className="btn btn-primary !w-auto"><Icon.Upload /><span>Upload Attachment</span></FileUploader>
            </div>}
            <div className="flex flex-col xl:flex-row lg:flex-row space-x-0 xl:space-x-2 lg:space-x-2 items-center">
              <span className="text-sm">Status: </span>
              <Status type="sm" value={get(selectedRequirement, 'status')}/>
              <span className="text-sm">Remarks: <span className="font-medium">{get(selectedRequirement, 'remarks')}</span></span>
            </div>
            
          </div>
          <div className={`flex p-2 overflow-auto ${selectedRequirement ? 'bg-gray-800' : ''}`} style={{ maxHeight: 600, height: 600 }}>
            {!selectedRequirement &&
            <span className="m-auto font-bold text-md text-gray-600">No current attachment</span> }
            {selectedRequirement && <img className="m-auto" src={get(selectedRequirement, 'requirement_url')} alt="attachment"/>}
          </div>
        </div>
      </div>
      {+get(appTransaction, 'transaction_kind') === 1 && !preview &&
      <div className="flex space-x-2 float-right">
        <Button type="button" onClick={onPrevious(value)} className="!bg-warning !w-auto !text-black">Previous</Button>
        <Button disabled={!isValidationPassed} type="button" onClick={onNext(value)} className="!bg-warning !w-auto !text-black">Next</Button>
      </div>}
      {+get(appTransaction, 'transaction_kind') === 2 && !preview &&
      <div className="flex space-x-2 float-right">
        <Button disabled={!isPassed} className="!w-auto">Submit</Button>
      </div>}
    </>
  )
}

export default ReuploadRequiredDocument